<template>
    <div class="wrapper wrapper-1" v-if="state.enter.show">
        <h1>地址提交</h1>
        <div class="row">
            <label><em>*</em>姓名：</label>
            <input
                type="text"
                v-model.trim="state.info.name"
                placeholder="请输入收件人姓名"
            />
        </div>
        <div class="row">
            <label><em>*</em>手机号码：</label>
            <input
                type="text"
                v-model.trim="state.info.phone"
                placeholder="请输入手机号码"
            />
        </div>
        <div class="row">
            <label><em>*</em>身份证号：</label>
            <input
                type="text"
                v-model.trim="state.info.id"
                placeholder="请输入身份证号码"
            />
        </div>
        <div class="row" style="margin-bottom: 10px">
            <label><em>*</em>邮寄地址：</label>
            <div class="select-wrapper">
                <select
                    v-model="state.selected.province"
                    @change="provinceSelect"
                >
                    <option value="-999">--省--</option>
                    <option
                        :value="item.value"
                        v-for="item in state.filters.provinces"
                        :key="item.code"
                    >
                        {{ item.value }}
                    </option>
                </select>
                <select v-model="state.selected.city" @change="citySelect">
                    <option value="-999">--市--</option>
                    <option
                        :value="item.value"
                        v-for="item in state.filters.citys"
                        :key="item.code"
                    >
                        {{ item.value }}
                    </option>
                </select>
                <select v-model="state.selected.street">
                    <option value="-999">--区--</option>
                    <option
                        :value="item.value"
                        v-for="item in state.filters.streets"
                        :key="item.code"
                    >
                        {{ item.value }}
                    </option>
                </select>
            </div>
            <div class="textarea-wrapper">
                <textarea
                    placeholder="请输入详细地址"
                    v-model.trim="state.info.detail"
                ></textarea>
            </div>
        </div>
        <div class="tips">
            <span>温馨提示：</span
            >由于奖品发放涉及到意外所得税上报缴纳，为了发放流程顺利，请确保收件人姓名与身份证件信息匹配，且信息无误。
        </div>
        <ul class="btns-wrapper">
            <li class="btn-submit" @click="confirmEvent">提交</li>
        </ul>
    </div>
    <div class="wrapper wrapper-2" v-if="state.detail.show">
        <h1>邮寄地址</h1>
        <div class="row">
            <label>姓名：</label>
            {{ state.info.name }}
        </div>
        <div class="row">
            <label>手机号码：</label>
            {{ state.info.phone }}
        </div>
        <div class="row">
            <label>身份证号：</label>
            {{ state.info.id }}
        </div>
        <div class="row">
            <label>邮寄地址：</label>
            {{ state.selected.province }}-{{ state.selected.city }}-{{
                state.selected.street
            }}
            {{ state.info.detail }}
        </div>
        <ul class="btns-wrapper">
            <li class="btn-change" @click="changeAddress">修改</li>
        </ul>
    </div>
    <Teleport to=".container">
        <ConfirmPop ref="confirmRef" />
    </Teleport>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, reactive, onMounted } from "vue";
import ConfirmPop from "./components/confirm-pop.vue";
import { GetAreas, SubmitAddress } from "../../api";
import { useUser } from "../../store/store";

const { user } = storeToRefs(useUser());
const confirmRef = ref(null);

const state = reactive({
    info: {
        name: "",
        id: "",
        phone: "",
        detail: ""
    },
    selected: {
        province: "-999",
        city: "-999",
        street: "-999"
    },
    filters: {
        provinces: [],
        citys: [],
        streets: []
    },
    enter: {
        show: false
    },
    detail: {
        show: false
    }
});

onMounted(async () => {
    const res = await GetAreas();
    state.filters.provinces = res;
});

// 省选择
const provinceSelect = () => {
    const filters = state.filters.provinces.filter(
        (item) => item.value == state.selected.province
    );
    state.filters.citys = [];
    state.selected.city = "-999";
    state.selected.street = "-999";
    if (filters.length > 0) {
        state.filters.citys = filters[0]["children"];
    } else {
        state.filters.citys = [];
    }
};
// 市选择
const citySelect = () => {
    const filters = state.filters.citys.filter(
        (item) => item.value == state.selected.city
    );
    state.filters.streets = [];
    state.selected.street = "-999";
    if (filters.length > 0) {
        state.filters.streets = filters[0]["children"];
    } else {
        state.filters.streets = [];
    }
};

// 修改地址
const changeAddress = () => {
    // 筛选城市
    const citys = state.filters.provinces.filter(
        (a) => a.value == state.selected.province
    )[0]["children"];
    state.filters.citys = citys;
    // 筛选地区
    const streets = citys.filter((c) => c.value == state.selected.city)[0][
        "children"
    ];
    state.filters.streets = streets;
    state.detail.show = false;
    state.enter.show = true;
};

// 确认
const confirmEvent = () => {
    if (!user.value.login_account) {
        return sdoLogin();
    }
    if (user.value.auth == "0") {
        return CsLib.alert("您无权提交！", 1200, "error");
    }
    if (!state.info.name) {
        return CsLib.alert("请输入您的真实姓名", 600, "error");
    }
    if (!CsLib.regxTel(state.info.phone)) {
        return CsLib.alert("收货人手机号码格式不正确", "error");
    }
    if (!state.info.id) {
        return CsLib.alert("请输入您的真实身份证号码", 600, "error");
    }
    if (
        state.selected.province == "-999" ||
        state.selected.city == "-999" ||
        state.selected.street == "-999"
    ) {
        return CsLib.alert("请选择所在省市区", "error");
    }
    if (!state.info.detail) {
        return CsLib.alert("请填写详细地址", "error");
    }
    const info = {
        name: state.info.name,
        phone: state.info.phone,
        cardid: state.info.id,
        address: `${state.selected.province}-${state.selected.city}-${state.selected.street} ${state.info.detail}`
    };
    confirmRef.value.Show(info);
};

defineExpose({
    Enter: () => {
        state.enter.show = true;
    },
    Detail: (data) => {
        state.enter.show = false;
        state.detail.show = true;
        state.info.name = data.name;
        state.info.id = data.cardid;
        state.info.phone = data.phone;
        const [areas, detail] = data.address.split(" ");
        state.selected.province = areas.split("-")[0];
        state.selected.city = areas.split("-")[1];
        state.selected.street = areas.split("-")[2];
        state.info.detail = detail;
    }
});
</script>

<style lang="scss" scoped>
.wrapper-1 {
    label {
        display: block;
        font-weight: bold;
        margin-bottom: 6px;
        position: relative;
        em {
            font-weight: bolder;
            color: #ff0000;
            margin-right: 6px;
            font-style: normal;
        }
    }
    input {
        width: 100%;
        height: 46px;
        border: 1px solid #ccc;
        text-indent: 1em;
        border-radius: 4px;
        transition: 0.3s;
        &:focus {
            border: 1px solid #409eff;
        }
    }
    .select-wrapper {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        select {
            width: 32%;
            border: 1px solid #ccc;
            height: 46px;
            text-indent: 1em;
            cursor: pointer;
            border-radius: 4px;
            transition: 0.3s;
            &:focus {
                border: 1px solid #409eff;
            }
        }
    }
    .textarea-wrapper {
        border: 1px solid #ccc;
        padding: 16px;
        textarea {
            border: none;
            width: 100%;
            height: 100px;
        }
    }
    .btn-submit {
        background: #337ab7;
        color: #fff;
        &:hover {
            background: #23527c;
        }
    }
    .btn-cancel {
        background: #d9534f;
        color: #fff;
        &:hover {
            background: #c9302c;
        }
    }
    .tips {
        color: #ff0000;
        position: relative;
        display: flex;
        span {
            width: 100px;
        }
    }
}
.wrapper-2 {
    .btn-change {
        background: #d9534f;
        color: #fff;
        &:hover {
            background: #c9302c;
        }
    }
}
</style>
